import { createSlice } from "@reduxjs/toolkit"
import {
  addMenu,
  getMenuList,
} from "store/actions/menusAction"

const initialState = {
  loading: true,
  isLoading: false,
  menus: [],
  menuList: [],
  menuDetails: {},
}

const usersSlice = createSlice({
  name: "menus",
  initialState,
  reducers: {},
  extraReducers: builder => {
    // GET ALL Menu LIST
    builder
      .addCase(getMenuList.pending, state => {
        state.loading = true
      })
      .addCase(getMenuList.fulfilled, (state, action) => {
        state.loading = false
        const { data } = action.payload
          state.menuList = data
        })
      .addCase(getMenuList.rejected, (state, action) => {
        state.loading = false
      })
  // ADD Menu
    builder
      .addCase(addMenu.pending, state => {
        state.isLoading = true
      })
      .addCase(addMenu.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addMenu.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export default usersSlice.reducer
